import upperFirst from 'lodash/upperFirst';
import { ThemeColorType } from '@sdk/theme/ThemeColorType';
import Text14 from '@sdk/components/ui/typography/Text14';
import gettext from '@sdk/lang/gettext';
import { ShiftFeedbackRating } from '@sdk/timesheets/types/ShiftFeedback';

import EmojiPoor from '@web/assets/svg/UI/emoji-poor.svg';
import EmojiFair from '@web/assets/svg/UI/emoji-fair.svg';
import EmojiGood from '@web/assets/svg/UI/emoji-good.svg';
import EmojiGreat from '@web/assets/svg/UI/emoji-great.svg';
import EmojiExcellent from '@web/assets/svg/UI/emoji-excellent.svg';

import { EmojiTile } from './shiftFeedbackNotificationModal.styles';

const emojiSvgMap = {
  [ShiftFeedbackRating.poor]: <EmojiPoor />,
  [ShiftFeedbackRating.fair]: <EmojiFair />,
  [ShiftFeedbackRating.good]: <EmojiGood />,
  [ShiftFeedbackRating.great]: <EmojiGreat />,
  [ShiftFeedbackRating.excellent]: <EmojiExcellent />,
};

type Props = {
  rating: ShiftFeedbackRating;
  onClick: () => void;
};

export const ShiftFeedbackRatingTile = ({ rating, onClick }: Props) => {
  return (
    <EmojiTile onClick={onClick}>
      {emojiSvgMap[rating]}
      <Text14 semiBold themeColor={ThemeColorType.primaryText}>
        {upperFirst(gettext(rating))}
      </Text14>
    </EmojiTile>
  );
};
